(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('RaceResumeController', RaceResumeController);

    RaceResumeController.$inject = ['RaceResume'];

    function RaceResumeController(RaceResume) {

        var vm = this;

        vm.raceResumes = [];

        loadAll();

        function loadAll() {
            RaceResume.query(function(result) {
                vm.raceResumes = result;
                vm.searchQuery = null;
            });
        }
    }
})();
